import React, { useState } from "react";
import "../../assets/styles/FileUploadModal.css";


const FileUploadModal = ({ isOpen, onClose, onFileSelect }) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
  };

  const handleSave = () => {
    if (file) {
      onFileSelect(file); // send file to parent
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fu-modal-overlay">
      <div className="fu-modal">
        <div className="fu-modal-header">
          <h3>Upload Photo</h3>
          <button className="fu-close-btn" onClick={onClose}>×</button>
        </div>
        <p className="fu-subtitle">Select and upload the File</p>

        <div className="fu-upload-box">
          <input
            type="file"
            id="fu-file-input"
            onChange={handleFileChange}
            hidden
            accept=".jpg,.jpeg,.png"
          />
          <label htmlFor="fu-file-input" className="fu-upload-label">
            Choose a file or drag & drop it here <br />
            <small>JPG, JPEG, PNG — up to 5MB</small>
          </label>
          <button
            className="fu-browse-btn"
            onClick={() => document.getElementById("fu-file-input").click()}
          >
            Browse File
          </button>
        </div>

        {file && (
          <div className="fu-file-preview">
            <span>{file.name}</span>
            <button className="fu-remove-btn" onClick={() => setFile(null)}>✕</button>
          </div>
        )}

        <div className="fu-actions">
          <button className="fu-cancel-btn" onClick={onClose}>Cancel</button>
          <button className="fu-save-btn" disabled={!file} onClick={handleSave}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};
export default FileUploadModal;
